import CpdIAReport from "../components/cpdIAReport";
import CpdMPFReport from "../components/cpdMPFReport";
import CpdSFCReport from "../components/cpdSFCReport";
import ReportDebitNote from "../components/reportDebitNote";
import ReportOrder from "../components/reportOrder";
import ReportIFastTransaction from "../components/reportIFastTransaction";
import ReportService from "../components/reportService";
import ReportUser from "../components/reportUser";
import ReportUserLoginActivities from "../components/reportUserLoginActivities";
import ReportActivityLog from "../components/reportActivityLog";
import ReportCommissionOverriding from "../components/reportCommissionOverriding";
import ReportUserNameCard from "../components/reportUserNameCard";
import ReportProduct from "../components/reportProduct";
import ReportMcaAudit from "../components/reportMcaAudit";
import ReportCommissionStatement from "../components/reportCommissionStatement";
import ReportWallet from "../components/reportWallet";
import ReportProviderPortal from "../components/reportProviderPortal";
import ReportClient from "../components/reportClient";
import ReportIALongTermPolicies from "../components/reportIALongTermPolicies";
import ReportIAMPFAcitivity from "../components/reportIAMPFAcitivity";
import ReportGIPendingRenewal from "../components/reportGIPendingRenewal";
import ReportGIRenewal from "../components/reportGIRenewal";
import ReportOrderRenewal from "../components/reportOrderRenewal";
import ReportCreditNote from "../components/reportCreditNote";
import ReportGIOutStandingPayment from "../components/reportGIOutStandingPayment";
import ReportGICommissionPayment from "../components/reportGICommissionPayment";
import ReportPendingCase from "../components/reportPendingCase";
import ReportAIRequest from "../components/reportAIRequest";
import ReportGIPendingSettlement from "../components/reportGIPendingSettlement";
import ReportGIInsurerOutstandingSettlement from "../components/reportGIInsurerOutstandingSettlement";
import ReportAccountPayableInsurer from "../components/reportAccountPayableInsurer";
import ReportGIOutstandingDocument from "../components/reportGIOutstandingDocument";
import ReportBankTransaction from "../components/reportBankTransaction";
import ReportClientPayment from "../components/reportClientPayment";
import ReportIncentiveCharge from "../components/reportIncentiveCharge";
import ReportIr56m from "../components/reportIr56m";
import ReportTrialBalance from "../components/reportTrialBalance";
import ReportProfitAndLoss from "../components/reportProfitAndLoss";
import ReportBalanceSheet from "../components/reportBalanceSheet";
import ReportSubledgerReconciliation from "../components/reportSubledgerReconciliation";
import ReportAging from "../components/reportAging";
import ReportCommissionAnalysis from "../components/reportCommissionAnalysis";
import ReportJournalRegister from "../components/reportJournalRegister";
import ReportGeneralLedger from "../components/reportGeneralLedger";
import ReportFinancialStatements from "../components/reportFinancialStatements";
import ReportFwdAb01ExpectedCommission from "../components/reportFwdAb01ExpectedCommission";
import ReportFwdAb02ActualCommission from "../components/reportFwdAb02ActualCommission";
import ReportFwdAb03BankAdviceSettlement from "../components/reportFwdAb03BankAdviceSettlement";
import ReportFwdAb05PayInBreakdown from "../components/reportFwdAb05PayInBreakdown";
import ReportFwdAb06PayOutBreakdown from "../components/reportFwdAb06PayOutBreakdown";
import ReportFwdBusinessSubmission from "../components/reportFwdBusinessSubmission";

export const REPORT_CATEGORIES = [
  {
    id: "orders",
    label: "Orders",
    reports: [
      { title: "Order Report", reportComponent: ReportOrder },
      {
        title: "IFast Transaction Report",
        reportComponent: ReportIFastTransaction,
      },
      { title: "Order Service Report", reportComponent: ReportService },
      { title: "Order Pending Case Report", reportComponent: ReportPendingCase },
      { title: "Order Renewal Report", reportComponent: ReportOrderRenewal },
      { title: "GI Renewal Report", reportComponent: ReportGIRenewal },
      {
        title: "GI Pending Renew DN Report",
        reportComponent: ReportGIPendingRenewal,
      },
      {
        title: "GI OutStanding Document Report",
        reportComponent: ReportGIOutstandingDocument,
      },
    ],
  },
  {
    id: "user",
    label: "User",
    reports: [
      { title: "User Report", reportComponent: ReportUser },
      {
        title: "User Login Activities Report",
        reportComponent: ReportUserLoginActivities,
      },
      { title: "Activity Log Report", reportComponent: ReportActivityLog },
      {
        title: "Commission Overriding Report",
        reportComponent: ReportCommissionOverriding,
      },
      { title: "Name Card Report", reportComponent: ReportUserNameCard },
      {
        title: "Provider Portal Login Report",
        reportComponent: ReportProviderPortal,
      },
      { title: "AI Request Report", reportComponent: ReportAIRequest },
    ],
  },
  {
    id: "client",
    label: "Client",
    reports: [{ title: "Client Report", reportComponent: ReportClient }],
  },
  {
    id: "accounting",
    label: "Accounting",
    reports: [
      { title: "GI Debit Note Report", reportComponent: ReportDebitNote },
      { title: "GI Credit Note Report", reportComponent: ReportCreditNote },
      {
        title: "Account Payable Report - Insurer",
        reportComponent: ReportAccountPayableInsurer,
      },
      {
        title: "Account Payable Report - Commission & OR",
        reportComponent: ReportGICommissionPayment,
      },
      {
        title: "Bank Transaction Report",
        reportComponent: ReportBankTransaction,
      },
      { title: "Client Payment Report", reportComponent: ReportClientPayment },
      {
        title: "GI OutStanding Payment Report",
        reportComponent: ReportGIOutStandingPayment,
      },
      {
        title: "GI Pending Settlement Report",
        reportComponent: ReportGIPendingSettlement,
      },
      {
        title: "GI Insurer Outstanding Settlement Report",
        reportComponent: ReportGIInsurerOutstandingSettlement,
      },
      {
        title: "Commission Statement Report",
        reportComponent: ReportCommissionStatement,
      },
      {
        title: "Incentive/Charge Report",
        reportComponent: ReportIncentiveCharge,
      },
      { title: "Wallet Report", reportComponent: ReportWallet },
      {
        title: "IR56M XML Report",
        subtitle:
          "Payments to consultants, freelancers, and subcontractors (IRD IR56M)",
        reportComponent: ReportIr56m,
      },
    ],
  },
  {
    id: "finance",
    label: "Finance",
    linkIds: ["A27", "M37"],
    reports: [
      {
        title: "accounting.financeReports.trialBalance.title",
        subtitle: "accounting.financeReports.trialBalance.subtitle",
        reportComponent: ReportTrialBalance,
      },
      {
        title: "accounting.financeReports.financialStatements.title",
        subtitle: "accounting.financeReports.financialStatements.subtitle",
        reportComponent: ReportFinancialStatements,
      },
      {
        title: "accounting.financeReports.pnl.title",
        subtitle: "accounting.financeReports.pnl.subtitle",
        reportComponent: ReportProfitAndLoss,
      },
      {
        title: "accounting.financeReports.balanceSheet.title",
        subtitle: "accounting.financeReports.balanceSheet.subtitle",
        reportComponent: ReportBalanceSheet,
      },
      {
        title: "accounting.financeReports.generalLedger.title",
        subtitle: "accounting.financeReports.generalLedger.subtitle",
        reportComponent: ReportGeneralLedger,
      },
      {
        title: "accounting.financeReports.journalRegister.title",
        subtitle: "accounting.financeReports.journalRegister.subtitle",
        reportComponent: ReportJournalRegister,
      },
      {
        title: "accounting.financeReports.subledgerReconciliation.title",
        subtitle: "accounting.financeReports.subledgerReconciliation.subtitle",
        reportComponent: ReportSubledgerReconciliation,
      },
      {
        title: "accounting.financeReports.aging.title",
        subtitle: "accounting.financeReports.aging.subtitle",
        reportComponent: ReportAging,
      },
      {
        title: "accounting.financeReports.commissionAnalysis.title",
        subtitle: "accounting.financeReports.commissionAnalysis.subtitle",
        reportComponent: ReportCommissionAnalysis,
      },
    ],
  },
  {
    id: "compliance",
    label: "Compliance",
    reports: [
      { title: "CPD IA Report", reportComponent: CpdIAReport },
      { title: "CPD MPF Report", reportComponent: CpdMPFReport },
      { title: "CPT SFC Report", reportComponent: CpdSFCReport },
      {
        title: "IA Encl 2 Report - Long Term Policies",
        reportComponent: ReportIALongTermPolicies,
      },
      {
        title: "IA Encl 10 Report - List of MPF Regulated Activities",
        reportComponent: ReportIAMPFAcitivity,
      },
      {
        title: "Approval Audit Report",
        subtitle: "MCA requests by submit date or approved date",
        reportComponent: ReportMcaAudit,
        requiresMca: true,
      },
    ],
  },
  {
    id: "product",
    label: "Product",
    reports: [{ title: "Product Report", reportComponent: ReportProduct }],
  },
  {
    id: "fwd",
    label: "FWD Reports",
    reports: [
      {
        title: "AB01 Expected Commission Report",
        subtitle:
          "Expected initial commission by application or policy received date",
        reportComponent: ReportFwdAb01ExpectedCommission,
      },
      {
        title: "AB02 Actual Commission Report",
        subtitle: "Payroll paid to users, one row per order",
        reportComponent: ReportFwdAb02ActualCommission,
      },
      {
        title: "AB03 Bank Advice and Pay-in Settlement Report",
        subtitle:
          "Bank advice by bank-in date, and the settled amount in each statement month",
        reportComponent: ReportFwdAb03BankAdviceSettlement,
      },
      {
        title: "AB05 Pay-in Breakdown Report",
        subtitle:
          "Confirmed commission received, matched to a policy or transaction",
        reportComponent: ReportFwdAb05PayInBreakdown,
      },
      {
        title: "AB06 Pay-out Breakdown Report",
        subtitle:
          "Payroll paid to users, user groups, and the company",
        reportComponent: ReportFwdAb06PayOutBreakdown,
      },
      {
        title: "Business Submission Report",
        subtitle:
          "New-business and actual GCI by channel, supplier, product, life agent, and B2B",
        reportComponent: ReportFwdBusinessSubmission,
      },
    ],
  },
];
